import { render, staticRenderFns } from "./HealthBarBox.vue?vue&type=template&id=30e3c24e&scoped=true"
import script from "./HealthBarBox.vue?vue&type=script&lang=js"
export * from "./HealthBarBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e3c24e",
  null
  
)

export default component.exports